<template>
  <component
    :is="tag"
    :id="id"
    :data-testid="id"
    :type="type"
    class="rhg-btn-link"
    :class="classes"
    :disabled="disabled"
    v-bind="{...dynamicProps}"
    @click="$emit('click')"
  >
    <span class="rhg-btn-link-text">
      <span class="rhg-btn-link-content">{{label}}</span>
      <i class="icon-arrow-right-nlp xs"></i>
    </span>
  </component>
</template>

<script>
import ArrowIcon from '../ArrowIcon/ArrowIcon.vue'

export default {
  name: 'ButtonLink',
  components: { ArrowIcon },
  props: {
    id: {
      type: String
    },
    label: {
      type: String,
      required: false
    },
    icon: {
      validator (value) {
        return ['left', 'right'].includes(value)
      }
    },
    type: {
      type: String
    },
    tag: {
      default: 'button',
      type: String
    },
    to: {
      default: '#',
      type: String
    },
    external: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    variant: {
      default: 'primary',
      validator (value) {
        return ['primary', 'light', 'dark'].includes(value)
      }
    },
    isFullWidth: {
      type: Boolean,
      default: false
    },
    isUppercase: {
      type: Boolean,
      default: true
    },
    isBold: {
      type: Boolean,
      default: true
    },
    size: {
      default: 'sm',
      validator (value) {
        return ['sm', 'md'].includes(value)
      }
    }
  },
  computed: {
    dynamicProps () {
      let externalLink = {}
      if (this.tag === 'a') {
        externalLink = { href: this.to, target: this.external ? '_blank' : false }
      }
      return externalLink
    },
    getIconColor () {
      const colors = {
        primary: '#C62525',
        light: '#FFFFFF',
        dark: '#242424'
      }

      return colors[this.variant]
    },
    classes () {
      const isLight = this.variant === 'light'
      const isDark = this.variant === 'dark'
      const isSmall = this.size === 'sm'
      const isMedium = this.size === 'md'

      return {
        'rhg-btn-link--small': isSmall,
        'rhg-btn-link--medium': isMedium,
        'rhg-btn-link__full-width': this.isFullWidth,
        'rhg-btn-link__dark': isDark,
        'rhg-btn-link__light': isLight,
        'rhg-btn-link__uppercase': this.isUppercase,
        'rhg-btn-link__bold': this.isBold
      }
    }
  }
}
</script>

<style lang="scss">
$primary:#C62525;
$hover:#9E0918;
$white: #FFFFFF;
$black: #242424;

.rhg-btn-link {
  color: $primary;
  background: none;
  border: none;

  &:hover span{
    color: $hover;
    cursor: pointer;
    .rhg-btn-link-content{
      text-decoration: underline;
    }
  }

  &-text {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  &--small {
    text-size-adjust: auto;
    font-size: 1.2rem;
    line-height: 1.6rem;

    .rhg-btn-link__arrow {
      font-size: 1.2rem;
      line-height: 1.6rem;
      width: 1.6rem;
      height: 1.6rem;
    }

    .rhg-btn-link-text {
      gap: 1.2rem
    }
  }

  &--medium {
    font-size: 1.6rem;
    line-height: 2.2rem;

    .rhg-btn-link__arrow {
      font-size: 1.6rem;
      line-height: 2.2rem;
      width: 2.2rem;
      height: 2.2rem;
    }

    .rhg-btn-link-text {
      gap: 1.4rem
    }
  }

  &__full-width {
    width: 31.2rem;
  }

  &__dark {
    color: $black;

    &:hover span{
      color: $black;
      .rhg-btn-link-content{
        text-decoration: underline;
      }
    }
  }

  &__light {
    color: $white;

    &:hover span{
      color: $white;
      .rhg-btn-link-content{
        text-decoration: underline;
      }
    }
  }
  &__uppercase {
    text-transform: uppercase;
  }
  &__bold {
    font-weight: bold;
  }
}
</style>
